import React from 'react';
const links = ['Termini di Servizio', 'Privacy Policy', 'Politica di Rimborso', 'Contatti'];
export function Footer() {
  return <footer className="w-full bg-white px-5 py-12" data-id="element-89" data-mp="3ggk6oqalp3xf">
      <div className="mx-auto max-w-5xl text-center" data-id="element-90" data-mp="32oe1fz8zkhcr">
        <p className="font-display text-xl font-black uppercase tracking-tight text-ink" data-id="element-91" data-mp="32lrlbb814tix">
          GINNASTICA ARTISTICA PRONTA™
        </p>
        <nav aria-label="Footer" data-id="element-92" data-mp="3ueiltxwqx4dz">
          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs font-semibold text-ink/55" data-id="element-93" data-mp="3ufjw405xtmun">
            {links.map(link => <li key={link} data-id="element-94" data-mp="3leviv7odbqit">
                <a href="#offer" className="transition-colors duration-150 ease-out hover:text-brand" data-id="element-95" data-mp="3ldkdx4j6scq4">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mx-auto mt-7 max-w-2xl text-[11px] leading-relaxed text-ink/40" data-id="element-96" data-mp="2ey05hxna5ycw">
          © 2026 GINNASTICA ARTISTICA PRONTA™. Tutti i diritti riservati.
        </p>
      </div>
    </footer>;
}